import en_US from './en_US.json'

export default {
  en_US: en_US,
}

export const localeFallback: { [key: string]: string } = {
  zh_HK: 'zh_TW',
  zh_MO: 'zh_TW',
}

export const languageFallback: { [key: string]: string } = {
  ar: 'ar_SA',
  bg: 'bg_BG',
  ca: 'ca_ES',
  cs: 'cs_CZ',
  da: 'da_DK',
  de: 'de_DE',
  el: 'el_GR',
  en: 'en_US',
  es: 'es_ES',
  et: 'et_EE',
  fi: 'fi_FI',
  fr: 'fr_FR',
  he: 'he_IL',
  hr: 'hr_HR',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KR',
  lt: 'lt_LT',
  lv: 'lv_LV',
  nb: 'nb_NO',
  nl: 'nl_NL',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ro: 'ro_RO',
  ru: 'ru_RU',
  sk: 'sk_SK',
  sl: 'sl_SI',
  sv: 'sv_SE',
  th: 'th_TH',
  tr: 'tr_TR',
  zh: 'zh_CN',
  nn: 'nb_NO',
  no: 'nb_NO',
  kk: 'en_US',
  sr: 'en_US',
  uk: 'en_US',
  vi: 'en_US',
}
